module.exports = __webpack_public_path__ + "img/50.af648de5.jpg";